<template>
  <SideMenu
    side-menu-width="667px"
    :title="title"
    :value="isTopDialog(componentName)"
    side-menu-auto-scroll-y
    side-menu-is-block
    @side-menu:click-close="handleInfoModalClose"
  >
    <slot />
  </SideMenu>
</template>

<script>
import SideMenu from 'www/vue_components/desktop/core/SideMenu.vue'
import ModalManager from 'www/vue_components/common/mixins/DialogManager'

import ClubInfoModalLogicV2
  from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/mixins/ClubInfoModalLogicV2'

export default {
  name: 'ClubInfoModal',
  components: {
    SideMenu,
  },
  mixins: [
    ModalManager,
    ClubInfoModalLogicV2,
  ],
}
</script>
